module.exports = __webpack_public_path__ + "img/1-4.fcabe9e9.png";